import { FilterParameter } from 'app/models/dto/filter-parameter.model';

export class UpdatedBusinessIndexFilterParameters {
    constructor(
        public filterParameters: FilterParameter[]
    ) {}
}
